import { render, staticRenderFns } from "./AddPosturaWithPadrillo.vue?vue&type=template&id=5a83edcc"
import script from "./AddPosturaWithPadrillo.vue?vue&type=script&lang=js"
export * from "./AddPosturaWithPadrillo.vue?vue&type=script&lang=js"
import style0 from "./AddPosturaWithPadrillo.vue?vue&type=style&index=0&id=5a83edcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports